import { ISvg } from "../../types/components/svgIcons.type";
import { ReactComponent as VisaCard } from "./visaCard.svg";
import { ReactComponent as MasterCard } from "./masterCard.svg";
import { ReactComponent as Amex } from "./amex.svg";
import { ReactComponent as Discover } from "./discover.svg";
import { ReactComponent as Reddit } from "./hugeicons_reddit.svg";
import { ReactComponent as Facebook } from "./iconoir_facebook.svg";
import { ReactComponent as Instagram } from "./iconoir_instagram.svg";
import { ReactComponent as Twitter } from "./mingcute_twitter-line.svg";
import { ReactComponent as Snail } from "./snail.svg";
import { ReactComponent as SnailWhite } from "./snail-white.svg";

const Svg: ISvg = {
  visa: VisaCard,
  mastercard: MasterCard,
  amex: Amex,
  discover: Discover,
  reddit: Reddit,
  facebook: Facebook,
  instagram: Instagram,
  twitter: Twitter,
  snail: Snail,
  snailWhite: SnailWhite,
};

export default Svg;
